// extracted by mini-css-extract-plugin
export default {"light":"styles_light__pkj02","header":"styles_header__Dx5Qn","headerNav":"styles_headerNav__X1X6q","coin":"styles_coin__rJ4Xs","buyButton":"styles_buyButton__2cyml"};